import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockSettings, { BlockJustify } from '../../../models/BlockSettings';
import SubBlockMenuData from './SubBlockMenuData';

class BlockMenuListEqualMobile2Data {
  title: BlockComponentText;
  titleImage: BlockComponentImage;
  backgroundImage: BlockComponentImage;
  menus: SubBlockMenuData[];
  settings: BlockSettings;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMenuListEqualMobile2Data {
  export function make(
    title?: string,
    titleImage?: string,
    backgroundImage?: string,
    menus?: SubBlockMenuData[],
    settings?: BlockSettings,
  ): BlockMenuListEqualMobile2Data {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      titleImage: titleImage ? BlockComponentImage.make(titleImage) : undefined,
      backgroundImage: BlockComponentImage.make(backgroundImage),
      menus,
      settings: settings || BlockSettings.getDefault(undefined, BlockJustify.START),
    };
  }

  export function getDefault(title = 'タイトル', titleImage = '', backgroundImage = ''): BlockMenuListEqualMobile2Data {
    return make(
      `<p><strong>${title}</strong></p>`,
      titleImage,
      backgroundImage,
      [
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
      ],
    );
  }
}

export default BlockMenuListEqualMobile2Data;
